function phone(value) {
  if (value) {
    const numbers = value
      .toString()
      .split('')
      .filter(char => /[0-9]/.test(char))
      .slice(-10);

    const areaCode = numbers.slice(0, 3);
    const firstThree = numbers.slice(3, 6);
    const lastFour = numbers.slice(6);

    return ['(', ...areaCode, ')', ' ', ...firstThree, '-', ...lastFour].join('');
  }

  return null;
}



export default phone;
